import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';

export class ObjectRelationLookupData {
    relationTypes: Array<DropdownOptionIntegerId>;
    primaryTargetObjects: Array<DropdownOptionIntegerId>;
    foreignTargetObjects: Array<DropdownOptionIntegerId>;
}
